import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  isApplied: false,
  currentStep: 1,
  completedPercentage: 0,
};

const corporateSlice = createSlice({
  name: "corporate",
  initialState,
  reducers: {
    setCorporateOnboarding: (state, action) => {
      const { status, isApplied, currentStep, completedPercentage } =
        action.payload || {};

      if (typeof status !== "undefined") state.status = status;
      if (typeof isApplied !== "undefined") state.isApplied = isApplied;
      if (typeof currentStep !== "undefined") state.currentStep = currentStep;
      if (typeof completedPercentage !== "undefined")
        state.completedPercentage = completedPercentage ?? 0;
    },
    setCorporateCompletedPercentage: (state, action) => {
      state.completedPercentage = action.payload ?? 0;
    },
    resetCorporateOnboarding: () => initialState,
  },
});

export const {
  setCorporateOnboarding,
  setCorporateCompletedPercentage,
  resetCorporateOnboarding,
} = corporateSlice.actions;

export default corporateSlice.reducer;


